export default {
  rf_lessons: {},
  spotlight_materials: {},
  blogs: [],
  campaigns: {},
  wwtk_items: [],
  recycle_right: {}
};
